/* eslint-disable no-undef */
/**
 * The default server URL to open if no other was specified.
 */

export const DEFAULT_SERVER_URL = process.env.REACT_APP_SERVER_URL;
